import React, {useEffect, useState} from 'react'
import Select from 'react-select'
import './index.scss';
import { i18nOptions } from '../../../../../constants/constants';
import { useDispatch, useSelector } from 'react-redux';
import PARENT_ACTIONS from '../../../state/parent/constants';

export default function DisplayLanguage(props) {
  const { label, i18n } = props;

  const dispatch = useDispatch()
  const printLanguage = useSelector(state => state.reports.parent.printLanguage)

  const languageOptions = i18nOptions.map(option => ({
    ...option,
    label: i18n.t(option.label, { ns: "common" })
  }))

  const selectedLanguage = languageOptions.find(option => option.value === printLanguage) || languageOptions[0];

  const handleChange = (option) => {
    // save to redux state.reports.parent.printLanguage so that it can persist across rendering
    dispatch({type: PARENT_ACTIONS.SET_PRINT_LANGUAGE, language: option.value})
  }

  useEffect(() => {
    i18n.changeLanguage(printLanguage)
  }, [printLanguage, i18n])

  return (
    <div className='display-language-select-container'>
      <div className='display-language-select-label'>{label}</div>
      <div className='display-language-select'>
        <Select
          classNamePrefix='teacherSecondarySelect'
          value={selectedLanguage}
          onChange={handleChange}
          options={languageOptions}
        />
      </div>
    </div>
  )
}